import { render } from "./MaintenanceView.vue?vue&type=template&id=97240d40"
import script from "./MaintenanceView.vue?vue&type=script&lang=js"
export * from "./MaintenanceView.vue?vue&type=script&lang=js"

import "./MaintenanceView.vue?vue&type=style&index=0&id=97240d40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__